'use client';

import Script from 'next/script'

export default function GoogleGTMPageViewComponent({title, section, depth}){
    return (
        <>
          <Script strategy="beforeInteractive"
              dangerouslySetInnerHTML={{
              __html: `
              window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: 'page_view',
                        pageContext: {
                          contentType: '${title}',
                          section : '${section.split(' ')[0]}',
                          subsection: '',
                          depthLevel: ${depth},
                          country: 'España',
                          language: 'es',
                        }
                    });
              `,
              }}
          />
          {/*<div id="pageview"*/}
          {/*    dangerouslySetInnerHTML={{*/}
          {/*      __html: `*/}
          {/*      <script id="pageViewGTM" type="text/javascript">*/}
          {/*        window.dataLayer = window.dataLayer || [];*/}
          {/*        function visit(content) {dataLayer.push(content);}*/}
          {/*          visit({*/}
          {/*              event: 'page_view',*/}
          {/*              pageContext: {*/}
          {/*                contentType: '${title}',*/}
          {/*                section : '${section}',*/}
          {/*                subsection: '',*/}
          {/*                depthLevel: 1,*/}
          {/*                country: 'España',*/}
          {/*                language: 'es',*/}
          {/*              }*/}
          {/*          });*/}
          {/*         </script>`*/}
          {/*}}></div>*/}
        </>
)}